import Axios from "../../../../api/axios/Axios";

export const getLatestHomeVideos = (params = {}) => {
  return Axios.get("/api/home/videos", {
    params: {
      search: "",
      limit: 10,
      offset: 0,
      ...params,
    },
  });
};
